import { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { WellnessCalendarUtilizationCard } from "../atoms"
import { WellnessCalendar, DefaultWellnessCalendar, Events } from "../../../assets/images"
import { handleAppError } from "../../handlers"
import { OverviewApi } from "../../../services"
import { CardSlider } from "../molecules"
import { SpinnerDotted } from "../../common/atoms"

const WellnessCalendarCard = ({ contractId, startDate, endDate, classes = '' }) => {
  const [state, setState] = useState({ loading: true })
  const history = useHistory()

  useEffect(() => {
    if(!contractId) return

    setState(prevState => { return {...prevState, loading: true} })
    OverviewApi.fetchWellnessCalendarOverview({ contract_id: contractId, start_date: startDate, end_date: endDate },
      (res) => {
        setState({...res.data, loading: false})
      },
      (err) => handleAppError(err)
    )
  }, [contractId])

  const { sponsored, upcoming_events = [], completed_events = [], loading } = state
  const ongoingEvents = upcoming_events.map((item) => <WellnessCalendarUtilizationCard key={item.name} classes='gap-4 px-4 py-4 m-3 w-90 h-full' svgsrc={item.image ?? DefaultWellnessCalendar} title={item.name} date={item.event_date} time={item.event_time} liner={`${item.total_participants} participants joined`}/>)
  const completedEvents = completed_events.map((item) => <WellnessCalendarUtilizationCard key={item.name} classes='gap-4 px-4 py-4 m-3 w-90 h-full' svgsrc={item.image ?? DefaultWellnessCalendar} title={item.name} date={item.event_date} time={item.event_time} liner={`${item.total_participants} participants joined`}/>)

  return (
    <div className={`bg-white border border-gray-200 rounded-lg py-6 ${classes}`}>
      <div className='flex justify-between items-center'>
        <div className='flex items-center gap-3 px-6'>
          <img className='h-8 w-8 mb-2' src={WellnessCalendar} alt='calendar' />
          <div className="flex flex-row gap-4">
            <span className={`text-base font-semibold text-gray-700 leading-none flex gap-4`}>{'Wellness calendar'}</span>
            { sponsored && <span className='text-white inline-block text-xs rounded-full px-2 py-1 -mt-1 bg-green-1000'>Sponsored</span>}
          </div>
        </div>
        <div className='text-base text-blue-600 px-6'>
          <button 
            className='border border-gray-275 rounded-md bg-white px-6 py-2 font-semibold mr-4'
            onClick={() => '/wellness-calendar/create-event' && history.push('/wellness-calendar/create-event')}
          >
            Create an event
          </button> 
          <button 
            className='border border-gray-275 rounded-md bg-white px-6 py-2 font-semibold'
            onClick={() => '/wellness-calendar' && history.push('/wellness-calendar')}
          >
            Wellness calendar
          </button>
        </div>
      </div>
      {
        !loading ? 
        <>
          { (ongoingEvents.length <= 0 && completedEvents.length <= 0) ?
              <div className='flex flex-col mt-6'>
                <h3 className='px-6 text-gray-500 text-xs font-semibold tracking-wider'>{'UPCOMING/COMPLETED EVENTS'}</h3>
                <div className="flex flex-col items-center">
                  <img className="h-44 w-60" src={Events} alt='events'/>
                  <h3 className="font-semibold text-base text-gray-700 mb-0">No upcoming/completed events</h3>
                </div>
              </div>
              :
              <div className='gap-6 mt-6'>
                <div className='flex flex-col'>
                  <h3 className='px-6 text-gray-500 text-xs font-semibold tracking-wider'>{'LIVE/UPCOMING EVENTS'}</h3>
                  {ongoingEvents.length > 0 ? 
                    <CardSlider classes='px-3' data={ongoingEvents} slidesToShow={3} slidesToScroll={3}/> 
                    : 
                    <h3 className="font-semibold text-base text-gray-700 flex flex-col items-center my-6 mb-0">No live/upcoming events</h3>
                  }
                </div>
                <div className='flex flex-col mt-6'>
                  <h3 className='px-6 text-gray-500 text-xs font-semibold tracking-wider'>{'COMPLETED EVENTS'}</h3>
                  {completedEvents.length > 0 ? 
                    <CardSlider classes='px-3' data={completedEvents} slidesToShow={3} slidesToScroll={3}/> 
                    : 
                    <h3 className="font-semibold text-base text-gray-700 flex flex-col items-center my-6 mb-0">No completed events</h3>
                  }
                </div>
              </div>
            }
        </> :
        <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }
    </div>
  )
}

export default WellnessCalendarCard